
<template>
  <section class="new-slider">
    <div class="new-slider-bg"></div>
    <div class="new-slider-cont">
      <div class="slider-header">
        <div class="slider-header-title">
          The Best <br/> Luxury Offerings
        </div>
        <div class="slider-header-desc">
          <div class="slider-header-desc-text">
            Exclusive villas, beachfront homes, and investment properties across the region — where turquoise waters meet your dream lifestyle
          </div>
          <div class="slider-header-desc-pagination">
            <div class="pagination-left" @click="changeSlide('left')">
              <SvgComponent name="arrow" />
            </div>
            <div class="pagination-right" @click="changeSlide('right')">
              <SvgComponent name="arrow" />
            </div>
          </div>
        </div>
      </div>

      <div class="slider-images-wrap" v-if="topListings" @scroll="updateSlideCounter">
        <div class="slider-images-item" v-for="(listing, i) in topListings" :key="listing.id"
            @click="$router.push({ name: 'SinglePage', params: { id: listing.link }})">
          <img 
            class="slider-images-item-image" 
            :src="$hostname + imgUrl(listing.image)" 
            :alt="listing.title"
          />
          <div class="slider-images-item-title">
            <span>{{ listing.title }}</span>
            <SvgComponent name="arrow-link2" />
          </div>
          <div class="slider-images-item-price">{{ listing.priceValue | toCurrency }}</div>
          <div class="slider-images-item-props">
            <div class="slider-images-item-prop" v-if="listing && listing.beds">
               {{ listing.beds }} BR
            </div>
            <div class="slider-images-item-prop" v-if="listing && listing.baths">
               {{ listing.baths }} BA
            </div>
            <div class="slider-images-item-prop" v-if="listing && listing.sqft">
               {{ listing.sqft }} SQFT
            </div>
          </div>
        </div>
      </div>

      <div class="slider-mobile-pagination">
        <div 
          class="slider-mobile-pagination-left" 
          @click="changeSlide('left')" 
          :class="{ disabled: !canScrollLeft }"
        >
          <SvgComponent name="arrow" />
        </div>
        <div class="slider-mobile-pagination-text">
          {{ currentSlide }} / {{ totalSlides }}
        </div>
        <div 
          class="slider-mobile-pagination-right" 
          @click="changeSlide('right')" 
          :class="{ disabled: !canScrollRight }"
        >
          <SvgComponent name="arrow" />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
    import SvgComponent from '@/components/SvgComponent.vue';
  
    export default {
    data() {
        
      return {
        topListings: null,
        currentSlide: 1,
        isScrolling: false,
      };
      
    },
    components: {
      SvgComponent,
    },
    computed: {
      totalSlides() {
        return this.topListings?.length || 0;
      },
      canScrollLeft() {
        return this.currentSlide > 1 && !this.isScrolling;
      },
      canScrollRight() {
        return this.currentSlide < this.totalSlides && !this.isScrolling;
      },

    },
    methods: {

     imgUrl(image) {
        return image.formats.large?.url || image.url;
      },
       preloadImage: function (item) {
        let img = new Image();
        img.src = this.$hostname + (item.image.formats.large?.url || item.image.url);
      },

     changeSlide: function (direction) {
      if (this.isScrolling) return;
      if (direction === 'left' && !this.canScrollLeft) return;
      if (direction === 'right' && !this.canScrollRight) return;

      const container = this.$el.querySelector('.slider-images-wrap');
      const card = container.querySelector('.slider-images-item');
      if (!card) return;

      const cardWidth = card.offsetWidth;
      const gap = parseInt(window.getComputedStyle(container).gap) || 0;
      const newSlide = direction === 'left' ? this.currentSlide - 1 : this.currentSlide + 1;
      const targetScroll = (newSlide - 1) * (cardWidth + gap);

      this.currentSlide = newSlide;
      this.isScrolling = true;
      this.smoothScrollTo(container, targetScroll, 1200);
     },

     smoothScrollTo(element, target, duration) {
      const start = element.scrollLeft;
      const distance = target - start;
      const startTime = performance.now();

      const easeOutCubic = (t) => 1 - Math.pow(1 - t, 3);

      const scroll = (currentTime) => {
        const elapsed = currentTime - startTime;
        const progress = Math.min(elapsed / duration, 1);
        const eased = easeOutCubic(progress);

        element.scrollLeft = start + (distance * eased);

        if (progress < 1) {
          requestAnimationFrame(scroll);
        } else {
          element.scrollLeft = target;
          this.isScrolling = false;
        }
      };

      requestAnimationFrame(scroll);
     },
     updateSlideCounter() {
        if (this.isScrolling) return;
        const container = this.$el.querySelector('.slider-images-wrap');
        const card = container.querySelector('.slider-images-item');
        if (!card) return;

        const cardWidth = card.offsetWidth;
        const gap = parseInt(window.getComputedStyle(container).gap) || 0;
        const scrollLeft = container.scrollLeft;

        const calculated = Math.round(scrollLeft / (cardWidth + gap)) + 1;
        this.currentSlide = Math.max(1, Math.min(calculated, this.totalSlides));
      },   
    },
     
     async mounted() {
        this.topListings = await this.$store.dispatch('getTopListings');
        this.topListings.forEach((item) => {
          this.preloadImage(item);
        });
      
      console.log('slider',this.topListings)
    },
    
    };

    
</script>

<style lang="scss">
.new-slider {
  user-select: none;
  display: contents;
  position: relative;
  width: 100%;

  &-bg {
    background: #1F1E1E;
  }

  &-cont {
    color: #FFFAF3;
    padding: 60px 0 50px;

    @include tablet {
      padding: 40px 0;
    }

    @include phone {
      padding: 32px 0 45px;
    }
  }

  .slider-header {
    display: flex;
    gap: 32px;
    margin-left: 100px;
    padding-left: 114px;
    padding-bottom: 38px;
    justify-content: center;

    @include tablet {
      gap: 20px;
      margin-left: 0;
      padding-left: 50px;
      padding-bottom: 22px;
    }

    @include miniTablet {
      padding-right: 20px;
    }

    @include phone {
      margin-left: 0;
      padding-left: 16px;
      padding-bottom: 0;
      justify-content: flex-start;
    }

    &-title {
      font-size: 72px;
      font-weight: 800;
      font-family: 'Abhaya Libre';
      text-align: right;
      /* width: 00px; */

      

      @include tablet {
        font-size: 50px;

        br {
          /* display: none; */
        }
      }

      @include phone {
        
        font-size: 42px;
        width: 280px;
        text-align: left;

        br {
          display: none;
        }
      }
    }

    &-desc {
      font-size: 18px;
      line-height: 1.5;
      width: 446px;

      @include tablet {
        width: 357px;
        line-height: 1;
        font-size: 16px;
      }

      @include miniTablet {
        width: 324px;
      }

      @include phone {
        display: none;
      }

      &-text {
        margin-top: 16px;

        @include tablet {
          margin-top: 8px;
          
        }
      }

      &-pagination {
        display: flex;
        gap: 62px;
        margin-top: 12px;

        .pagination-right {
          transform: rotate(180deg);
        }

        .pagination-right, .pagination-left {
          cursor: pointer;

          &:hover {
            color: #D41E34;
          }

          &.disabled {
            opacity: 0.3;
            pointer-events: none;
            cursor: default;
          }
        }
      }
    }
  }

  .slider-images-wrap {
    display: flex;
    overflow: scroll;
    gap: 40px;
    padding: 20px 0;



    @include tablet {
      width: 100vw;
      gap: 30px;
    }

    @include phone {
      width: 100vw;
      margin-top: 24px;
      gap: 16px;
      scroll-snap-type: none;
      padding-bottom: 24px;
    }

    &::-webkit-scrollbar-track {
      display: none;
    }

    &::-webkit-scrollbar {
      display: none;
    }

    .slider-images-item {
      width: 938px;
      height: 612px;
      flex-shrink: 0;
      position: relative;
      display: flex;
      flex-direction: column;
      gap: 8px;
      justify-content: flex-end;
      padding: 40px;
      transition: transform 0.2s ease-in;
      cursor: pointer;

      &:before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: linear-gradient(180deg, rgba(0, 0, 0, 0) 70.02%, rgba(0, 0, 0, 0.405) 84.28%, rgba(0, 0, 0, 0.45) 100%);
        z-index: 2;

        @include phone {
          display: none;
        }
      }

      &:hover {
        transform: scale(1.05);
        transition: transform 0.2s ease-in;
      }


      @include middle {
        width: 750px;
        height: 490px;
      }

      @include tablet {
        width: 545px;
        height: 355px;
        padding: 32px;

        &:hover {
          transform: scale(1);
        }
      }

      @include phone {
        width: 320px;
        height: max-content;
        padding: 0;
        &:hover {
         transform: scale(1);
        }
      }

      &:first-child {
        margin-left: 100px;

        @include tablet {
          margin-left: 50px;
        }

        @include phone {
          margin-left: 16px;
        }
      }

      &:last-child {
        margin-right: 100px;

        @include tablet {
          margin-right: 50px;
        }

        @include phone {
          margin-right: 16px;
        }
      }

      &-image {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
        z-index: 0;

        @include phone {
          position: relative;
          width: 320px;
          height: 320px;
        }

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }

      &-title {
        z-index: 2;
        font-size: 40px;
        cursor: pointer;
        display: flex;
        align-items: center;
        gap: 14px;
        color: white;
        line-height: 100%;
        

        span {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        @include middle {
          font-size: 26px;
          line-height: 30px;
          gap: 12px;
        }

        @include tablet {
          font-size: 24px;
          line-height: 24px;
        }

        @include miniTablet {
          font-size: 22px;
          line-height: 22px;
        }

        svg {
          /* transform: scale(1.9);
          filter: brightness(0) invert(1); */
          flex-shrink: 0;

          @include middle {
            scale: 0.75;
          }

          @include miniTablet {
            scale: 0.7;
          }


          @include phone {
            display: none;
          }
        }

        @include phone {
          font-size: 28px;
        }
      }

      &-price {
        z-index: 2;
        font-size: 18px;
        font-weight: 700;
        color: white;

        @include middle {
          font-size: 18px;
          line-height: 21px;
        }

        @include tablet {
          font-size: 16px;
        }
      }

      &-props {
        z-index: 2;
        height: 22px;
        display: flex;
        gap: 14px;
        font-size: 18px;
        color: white;

        

        @include tablet {
          font-size: 16px;
          height: 20px;
          gap: 5px;
        }
      }
    }
  }

  .slider-mobile-pagination {
    background: #FFFAF3;
    margin: 0 16px;
    justify-content: space-between;
    padding: 20px;
    box-sizing: border-box;
    display: none;

    @include phone {
      display: flex;
    }

    svg {
      color: #1F1E1E;
    }

    &-right {
      transform: rotate(180deg);
    }

    &-text {
      color: black;
      font-size: 17px;
      font-weight: 700;
      display: flex;
      align-items: center;
    }

    .slider-mobile-pagination-left, .slider-mobile-pagination-right {
      &.disabled {
        opacity: 0.5;
        pointer-events: none;
        cursor: default;
      }
    }
  }
}
    
</style>